import { css } from "styled-components";

export const buttonAppearance = () => css`
  font-weight: 500;
  text-align: center;
  padding: 0 1rem;
  border-radius: 2px;
  border: 2px solid transparent;
  height: 3rem;
  cursor: pointer;
  text-transform: uppercase;

  &[disabled] {
    opacity: 0.33;
  }
`;

export const buttonReset = () => css`
  appearance: none;
  background: transparent;
  border: none;
`;

export const linkReset = () => css`
  text-decoration: none;
`;

export const linkAppearance = () => css`
  font-weight: 500;
  color: #213f5a;
  text-decoration: none;
`;
